import { Box, styled, Tabs, tabsClasses } from '@mui/material';
import { ServiceAgreementDetailResponse } from 'ogp/services/service-agreements.types';
import { useState } from 'react';
import { LwTab, ModalPanelTabType } from 'redesign';
import { useGetServiceAgreementDetailsTab } from './get-service-agreement-detail-tabs';

export const ServiceAgreementDetailTabs = ({ data }: { data: ServiceAgreementDetailResponse }) => {
  const tabs: ModalPanelTabType[] = useGetServiceAgreementDetailsTab(data);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  return (
    <Box>
      <Box mb={4}>
        <StyledTabs
          value={selectedTab.id}
          onChange={(_, tabId) => {
            const selectedTab = tabs.find((i) => i.id === tabId) ?? tabs[0].id;
            setSelectedTab(selectedTab);
          }}
          aria-label="partner-detail-tabs"
        >
          {tabs.map((tab) => (
            <LwTab key={tab.id} value={tab.id} label={tab.tabLabel} />
          ))}
        </StyledTabs>
      </Box>
      <Box>{selectedTab.element}</Box>
    </Box>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  [`& div.${tabsClasses.scroller}`]: {
    [`& .${tabsClasses.flexContainer}`]: {
      gap: theme.spacing(2),
      overflow: 'visible',
    },
  },
}));
